var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallpassTokenFlat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    role: "img",
    "aria-label": "WallPass token logo (flat)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 252,
    fill: "#D99E1B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 212,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 14,
    opacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M379.94 256.88C390.40 256.88 400.34 247.00 402.80 237.30C407.99 216.78 396.42 198.53 374.56 198.73L326.70 198.99C325.69 199.00 324.88 199.81 324.88 200.82L325.17 335.49C325.17 336.50 324.35 337.32 323.35 337.32L301.18 337.32C300.17 337.32 299.35 336.50 299.35 335.50L299.35 230.07C299.35 228.08 296.61 227.53 295.84 229.37L251.21 336.22C251.04 336.62 250.72 336.96 250.33 337.15C250.08 337.27 249.80 337.34 249.53 337.34L230.38 337.33C229.66 337.33 229.01 336.91 228.72 336.26L168.15 203.37C167.60 202.16 168.48 200.78 169.81 200.78L193.69 200.78C194.41 200.78 195.06 201.20 195.36 201.86L236.91 293.98C237.57 295.44 239.65 295.40 240.26 293.92L288.83 175.83C289.12 175.15 289.78 174.70 290.52 174.70L377.80 174.67C377.84 174.67 377.88 174.67 377.91 174.67C444.77 178.37 449.17 277.46 379.60 280.46M110.43 174.66L160.15 297.84L181.52 252.43L195.34 282.41C195.59 283.07 195.22 283.61 195.01 284.18C193.27 289.08 189.79 295.49 187.50 300.42C181.82 312.68 175.81 324.81 170.27 337.14L148.01 337.29L82.08 174.66ZM110.43 174.66M373.79 243.95L373.79 295.89L328.82 269.92ZM373.79 243.95",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallpassTokenFlat);
export default __webpack_public_path__ + "static/media/wallpass-token-flat.37f467bebd6dedb4a98a56eb29aa5ba5.svg";
export { ForwardRef as ReactComponent };